module.exports = __webpack_public_path__ + "media/images/icons/x-04d822cd563b4e594fee69d9f8d08735.png";